import React, { useState, useEffect } from "react";
import { Tab, Nav, Button, Container, Row, Col } from "react-bootstrap";
import PpcAgreement from "./ppc/PpcAgreement";
import PpcServices from "./ppc/PpcServices";
import updateParams from "utils/updateParams.js";
import SEO from "./seo/SEO";
let seodot = require("images/icons/seo-dot.png");
seodot = <img className="pl-2" src={`/datapulse${seodot}`} />;
let ppcdot = require("images/icons/ppc-dot.png");
ppcdot = <img className="pl-2" src={`/datapulse${ppcdot}`} />;
let disableddot = require("images/icons/disabled-dot.png");
disableddot = <img className="pl-2" src={`/datapulse${disableddot}`} />;

export default function Services(props) {
  const [tabLocation, setTabLocation] = useState("");

  // const [isPpcEnabled, setIsPpcEnabled] = useState(props.isPpcEnabled);
  const [isSeoEnabled, setIsSeoEnabled] = useState(props.isSeoEnabled);

  useEffect(() => {
    setTabLocation(props.servicePicker(new URL(location.href).searchParams));
  }, []);

  const selectTab = (key) => {
    setTabLocation(key);
    updateParams("sub_page", key);
  };

  return (
    <>
      <div className="pb-4 pt-3 px-5 trim-padding">
        <Tab.Container id="services-agreement-subtabs" defaultActiveKey="ppc" activeKey={tabLocation} onSelect={(k) => selectTab(k)}>
          <Nav variant="pills" className="mt-4 pb-0 nav-fill tabs-navigation-3 row no-gutters row-cols-sm-1 row-cols-md-2">
            <Nav.Item className="col">
              <Nav.Link eventKey="ppc">
                <div className="d-flex justify-content-center">
                  <p className="mb-0 ppc-tab">PPC</p>
                  {props.isPpcEnabled ? (
                    <small className="enabled">Currently enabled{ppcdot}</small>
                  ) : (
                    <small className="enabled">Currently disabled{disableddot}</small>
                  )}
                </div>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="col">
              <Nav.Link eventKey="seo">
                <div className="d-flex justify-content-center">
                  <p className="mb-0 seo-tab">SEO</p>
                  {isSeoEnabled ? (
                    <small className="enabled">Currently enabled{seodot}</small>
                  ) : (
                    <small className="enabled">Currently disabled{disableddot}</small>
                  )}
                </div>
              </Nav.Link>
            </Nav.Item>
          </Nav>
          <Tab.Content>
            <Tab.Pane eventKey="ppc">
              <div className="top-div">
                <PpcAgreement isEnabled={props.isPpcEnabled} setIsEnabled={props.setIsPpcEnabled} {...props} />
                <PpcServices {...props} isEnabled={props.isPpcEnabled} setIsEnabled={props.setIsPpcEnabled} />
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="seo">
              <SEO isEnabled={isSeoEnabled} isPpcEnabled={props.isPpcEnabled} setIsEnabled={setIsSeoEnabled} {...props} />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </>
  );
}
